var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 85,
    height: 85,
    rx: 42.5,
    fill: "#FFF3DC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 32.5V43L50 46.5",
    stroke: "#ED9500",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0017 60.5005C52.6667 60.5005 60.5017 52.6655 60.5017 43.0005C60.5017 33.3355 52.6667 25.5005 43.0017 25.5005C33.3367 25.5005 25.5017 33.3355 25.5017 43.0005C25.5017 52.6655 33.3367 60.5005 43.0017 60.5005Z",
    stroke: "#ED9500",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockOrange);
export default __webpack_public_path__ + "static/media/clock_orange.a9458fdb7fffef2ba2c52420b02ea912.svg";
export { ForwardRef as ReactComponent };